import { render, staticRenderFns } from "./ExpandedFilter.vue?vue&type=template&id=5a0dd20a&scoped=true&"
import script from "./ExpandedFilter.vue?vue&type=script&lang=js&"
export * from "./ExpandedFilter.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedFilter.vue?vue&type=style&index=0&id=5a0dd20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0dd20a",
  null
  
)

export default component.exports